import { Controller } from "stimulus";

// Connects to data-controller="toggle-containers"
// This controller toggles the visibility of two containers
export default class extends Controller {
  static targets = ["scrollContainer"];

  connect() {
    console.log("ToggleContainersController connected");
  }

  toggle() {
    const isHidden = this.scrollContainerTarget.style.display === "none" || 
                     this.scrollContainerTarget.style.display === "";
    
    if (isHidden) {
      this.scrollContainerTarget.style.display = "block";
      // Add overlay to close filters when clicking outside
      this.addOverlay();
    } else {
      this.scrollContainerTarget.style.display = "none";
      this.removeOverlay();
    }
  }

  addOverlay() {
    const overlay = document.createElement('div');
    overlay.id = 'filter-overlay';
    overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.3); z-index: 999;';
    overlay.addEventListener('click', () => this.toggle());
    document.body.appendChild(overlay);
  }

  removeOverlay() {
    const overlay = document.getElementById('filter-overlay');
    if (overlay) {
      overlay.remove();
    }
  }
}